import { createBlock } from '@lib/features/blocks/blocks';
import { useEffect } from 'react';
import EventCards from './EventCards';
import { useEvents } from './useEvents';

const useEverydayEvents = () => {
  const { trigger, items } = useEvents();
  useEffect(() => {
    trigger({ isEverydayEvent: true, orderBy: 'RAND()', includePastEvents: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return items;
};

const EverydayEventsBlock = createBlock<'blocks_everydayEvents_BlockType'>(
  ({ heading, content }) => {
    const items = useEverydayEvents();

    return (
      <EventCards
        {...{
          heading,
          content,
          items,
        }}
      />
    );
  }
);

export default EverydayEventsBlock;
